import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={41}
    fill="none"
    viewBox="0 0 11 41"
    {...props}
  >
    <path
      fill={props.color||"#24EAA8"}
      d="M5.22 10.44A5.22 5.22 0 1 0 5.22 0a5.22 5.22 0 0 0 0 10.44ZM5.22 25.4a5.22 5.22 0 1 0 0-10.44 5.22 5.22 0 0 0 0 10.44ZM5.22 40.35a5.22 5.22 0 1 0 0-10.44 5.22 5.22 0 0 0 0 10.44Z"
    />
  </svg>
)
export default SvgComponent
